import { Component, isValidElement, createElement } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { getMessagesForLocale } from './helpers';

@inject('AppState')
@observer
export default class FormattedMessage extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
		id: PropTypes.string.isRequired,
		values: PropTypes.object,
		defaultMessage: PropTypes.string,
	};

	static defaultProps = {
		values: {},
		defaultMessage: '',
	};

	elements = {};
	tokenizedValues = {};

	hasValues() {
		return this.props.values && Object.keys(this.props.values).length > 0;
	}

	hasElements() {
		return this.elements && Object.keys(this.elements).length > 0;
	}

	generateToken = (() => {
		let counter = 0;

		return uid => `ELEMENT-${uid}-${(counter += 1)}`;
	})();

	addValues(values, msg) {
		let formattedMessage = msg;
		Object.keys(values).map(key => {
			formattedMessage = formattedMessage.replace(`{${key}}`, values[key]);
		});

		return formattedMessage;
	}

	createTokenizedValues(uid, tokenDelimiter) {
		Object.keys(this.props.values).forEach(name => {
			const value = this.props.values[name];

			if (isValidElement(value)) {
				const token = this.generateToken(uid);
				this.tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
				this.elements[token] = value;
			}
		});
	}

	replaceTokenizedValues(formattedMessage, tokenDelimiter) {
		let nodes;

		if (this.hasElements()) {
			nodes = formattedMessage
				.split(tokenDelimiter)
				.filter(part => !!part)
				.map(part => this.elements[part] || part);
		} else {
			nodes = [formattedMessage];
		}

		return nodes;
	}

	format(msg) {
		let uid, tokenDelimiter, nodes;

		if (this.hasValues()) {
			 uid = Math.floor(Math.random() * 0x10000000000).toString(16); //eslint-disable-line
			tokenDelimiter = `@__${uid}__@`;

			this.createTokenizedValues(uid, tokenDelimiter);
			const values = Object.values(this.tokenizedValues).length
				? this.tokenizedValues
				: this.props.values;

			const formattedMessage = this.addValues(values, msg);

			nodes = this.replaceTokenizedValues(formattedMessage, tokenDelimiter);
		} else {
			return new Array(msg);
		}

		return nodes;
	}

	render() {
		const { id, defaultMessage } = this.props;
		const { locale } = this.props.AppState;

		const messageForLocale = getMessagesForLocale(locale)[id];
		let nodes;
		if (!messageForLocale && defaultMessage === '') {
			nodes = this.format(getMessagesForLocale(locale).request_failed);
		} else {
			nodes = messageForLocale
				? this.format(messageForLocale)
				: new Array(defaultMessage);
		}

		return createElement('span', null, ...nodes);
	}
}



// WEBPACK FOOTER //
// ./src/ui/i18n/FormattedMessage.js